import de from './de.json';
import en from './en.json';
import it from './it.json';
import cs from './cs.json';
import sk from './sk.json';
import bs from './bs.json';
import hr from './hr.json';
import ro from './ro.json';
import hu from './hu.json';
import pl from './pl.json';
import bg from './bg.json';
import ru from './ru.json';
import ko from './ko.json';
import fa from './fa.json';

// Export each language individually to allow for direct imports
export { de, en, it, cs, sk, bs, hr, ro, hu, pl, bg, ru, ko, fa };

// Export default for backward compatibility
export default {
  de,
  en,
  it,
  cs,
  sk,
  bs,
  hr,
  ro,
  hu,
  pl,
  bg,
  ru,
  ko,
  fa,
};
